<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card elevation="0" tile>
        <v-card-title class="grey lighten-4">
          {{ $t("hr.menu.imprest_request_history") }}
          <v-spacer />
          <id-button @click="onRefreshData">
            <template #icon>
              <v-icon left>mdi-refresh</v-icon>
            </template>
            {{ $t("buttons.refresh") }}
          </id-button>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :options.sync="table.options"
          :server-items-length="table.totalItems"
          single-select
          :loading="table.loading"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
          class="elevation-1"
        >
          <template #item="row">
            <tr :active="row.selected">
              <td><employee-profile :employee="row.item.imprest.employee" /></td>
              <td>{{ $helpers.getConvertCurrency(row.item.imprest.requested) }}</td>
              <td>{{ $helpers.getConvertCurrency(row.item.imprest.approved) }}</td>
              <td>
                {{ row.item.imprest.timestamp | formattedDate }}
              </td>
              <td>
                <template v-if="row.item.imprest.travel">
                  <p class="ma-0 caption">
                    <v-icon size="20" color="teal">mdi-account</v-icon>
                    {{ row.item.imprest.travel.employee.firstName }}
                    {{ row.item.imprest.travel.employee.lastName }}
                  </p>
                  <p class="ma-0 caption">
                    <v-icon size="20" color="teal">mdi-map-marker</v-icon>{{ row.item.imprestimprest.travel.address }}
                  </p>
                  <p class="ma-0 caption">
                    <v-icon size="20" color="teal">mdi-calendar-range</v-icon>
                    {{ row.item.imprest.travel.beginDate | formattedDateTimeMinute }} -
                    {{ row.item.imprest.travel.endDate | formattedDateTimeMinute }}
                  </p>
                </template>
                <v-icon v-else color="red">mdi-close</v-icon>
              </td>
              <td>
                <template v-if="row.item.imprest.expenseManagement">
                  <p class="ma-0">
                    {{ row.item.imprest.expenseManagement.name }}
                  </p>
                  <p v-if="row.item.imprest.expenseManagement.project" class="ma-0 caption">
                    <v-avatar size="14" :color="row.item.imprest.expenseManagement.project.color" />
                    {{ row.item.imprest.expenseManagement.project.name }}
                  </p>
                </template>
                <v-icon v-else color="red">mdi-close</v-icon>
              </td>
              <td>
                <request-status-label :status="row.item.imprest.requestStatus" />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  /**
   * @author Ali Hüseyin ŞİRELİ
   * @email ali.sireli@globme.com.tr
   * @create date 2021-01-13 14:02:37
   * @modify date 2021-01-13 14:02:37
   * @desc ImprestRequestHistory
   */
  import { APPROVAL_IMPREST_REQUESTS } from "../../query";

  export default {
    name: "ImprestRequestHistory",
    components: { RequestStatusLabel: () => import("@/components/global/request-status-label") },
    data: vm => ({
      table: {
        loading: false,
        data: [],
        criteria: {},
        options: {},
        pagination: {
          rowsPerPage: 10,
          sortBy: "createdDateTime",
          descending: true
        },
        totalItems: 0,
        totalPages: 0,
        selected: [],
        headers: [
          {
            text: vm.$t("global.employee"),
            value: "imprest.employee.firstName",
            align: "left",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.imprest.amount"),
            value: "imprest.requested.amount",
            align: "left",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.imprest.approved_amount"),
            value: "imprest.approved.amount",
            align: "left",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.imprest.date"),
            value: "imprest.timestamp",
            align: "left",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.imprest.travel"),
            value: "",
            align: "left",
            sortable: false,
            class: ["primary--text"]
          },
          {
            text: vm.$t("global.expense_management"),
            value: "",
            align: "left",
            sortable: false,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.imprest.status"),
            value: "imprest.requestStatus",
            align: "left",
            sortable: false,
            class: ["primary--text"]
          }
        ]
      }
    }),
    watch: {
      "table.options": {
        handler(options) {
          let { itemsPerPage, page } = options;
          this.table.pagination.rowsPerPage = itemsPerPage;
          this.table.pagination.page = page;
          this.fetchItems();
        },
        deep: true
      }
    },
    methods: {
      onRefreshData() {
        this.fetchItems();
      },
      async fetchItems() {
        this.table.loading = true;
        await this.$apollo
          .query({
            query: APPROVAL_IMPREST_REQUESTS,
            variables: {
              id: this.$store.state.auth.user.id
            }
          })
          .then(({ data, errors }) => {
            if (!errors && !data.error) {
              this.table.data = data.employee.approvalImprestRequests || [];
              this.table.totalItems = data.employee.approvalImprestRequests.length || 0;
            }
          })
          .catch(e => {
            this.$helpers.showNotification(e.message);
          })
          .finally(() => (this.table.loading = false));
      }
    }
  };
</script>

<style scoped></style>
